import { cn as e } from "../utils/index.js";
import { Icon as t } from "./icons/icons.js";
import "./icons/index.js";
import "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import * as i from "@radix-ui/react-dropdown-menu";
//#region src/components/dropdown-menu.tsx
function a({ ...e }) {
	return /* @__PURE__ */ n(i.Root, {
		"data-slot": "dropdown-menu",
		...e
	});
}
function o({ ...e }) {
	return /* @__PURE__ */ n(i.Portal, {
		"data-slot": "dropdown-menu-portal",
		...e
	});
}
function s({ ...e }) {
	return /* @__PURE__ */ n(i.Trigger, {
		"data-slot": "dropdown-menu-trigger",
		...e
	});
}
function c({ className: t, sideOffset: r = 4, ...a }) {
	return /* @__PURE__ */ n(i.Portal, { children: /* @__PURE__ */ n(i.Content, {
		"data-slot": "dropdown-menu-content",
		sideOffset: r,
		className: e("bg-popover text-popover-foreground z-50 max-h-(--radix-dropdown-menu-content-available-height) min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md", "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95", "data-[state=closed]:animate-out data-[state=closed]:fade-out-0  data-[state=closed]:zoom-out-95", "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", t),
		...a
	}) });
}
function l({ ...e }) {
	return /* @__PURE__ */ n(i.Group, {
		"data-slot": "dropdown-menu-group",
		...e
	});
}
function u({ className: t, inset: r, variant: a = "default", ...o }) {
	return /* @__PURE__ */ n(i.Item, {
		"data-slot": "dropdown-menu-item",
		"data-inset": r,
		"data-variant": a,
		className: e("focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", t),
		...o
	});
}
function d({ className: a, children: o, checked: s, ...c }) {
	return /* @__PURE__ */ r(i.CheckboxItem, {
		"data-slot": "dropdown-menu-checkbox-item",
		className: e("focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-4 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", s ? "font-medium" : "", a),
		checked: s,
		...c,
		children: [o, /* @__PURE__ */ n("span", {
			className: "pointer-events-none absolute right-2 flex size-3.5 items-center justify-center",
			children: /* @__PURE__ */ n(i.ItemIndicator, { children: /* @__PURE__ */ n(t, {
				name: "check",
				size: "sm",
				className: "text-(--seafoam-500)"
			}) })
		})]
	});
}
function f({ ...e }) {
	return /* @__PURE__ */ n(i.RadioGroup, {
		"data-slot": "dropdown-menu-radio-group",
		...e
	});
}
function p({ className: a, children: o, ...s }) {
	return /* @__PURE__ */ r(i.RadioItem, {
		"data-slot": "dropdown-menu-radio-item",
		className: e("focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", a),
		...s,
		children: [/* @__PURE__ */ n("span", {
			className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center",
			children: /* @__PURE__ */ n(i.ItemIndicator, { children: /* @__PURE__ */ n(t, {
				name: "check",
				size: "sm",
				className: "text-(--seafoam-500)"
			}) })
		}), o]
	});
}
function m({ className: t, inset: r, ...a }) {
	return /* @__PURE__ */ n(i.Label, {
		"data-slot": "dropdown-menu-label",
		"data-inset": r,
		className: e("px-2 py-1.5 text-sm font-medium data-[inset]:pl-8", t),
		...a
	});
}
function h({ className: t, ...r }) {
	return /* @__PURE__ */ n(i.Separator, {
		"data-slot": "dropdown-menu-separator",
		className: e("bg-border -mx-1 my-1 h-px", t),
		...r
	});
}
function g({ className: t, ...r }) {
	return /* @__PURE__ */ n("span", {
		"data-slot": "dropdown-menu-shortcut",
		className: e("text-muted-foreground ml-auto text-xs tracking-widest", t),
		...r
	});
}
function _({ ...e }) {
	return /* @__PURE__ */ n(i.Sub, {
		"data-slot": "dropdown-menu-sub",
		...e
	});
}
function v({ className: a, inset: o, children: s, ...c }) {
	return /* @__PURE__ */ r(i.SubTrigger, {
		"data-slot": "dropdown-menu-sub-trigger",
		"data-inset": o,
		className: e("focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", a),
		...c,
		children: [s, /* @__PURE__ */ n(t, {
			name: "chevron_right",
			size: "sm",
			className: "ml-auto"
		})]
	});
}
function y({ className: t, ...r }) {
	return /* @__PURE__ */ n(i.SubContent, {
		"data-slot": "dropdown-menu-sub-content",
		className: e("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-hidden rounded-md border p-1 shadow-lg", t),
		...r
	});
}
//#endregion
export { a as DropdownMenu, d as DropdownMenuCheckboxItem, c as DropdownMenuContent, l as DropdownMenuGroup, u as DropdownMenuItem, m as DropdownMenuLabel, o as DropdownMenuPortal, f as DropdownMenuRadioGroup, p as DropdownMenuRadioItem, h as DropdownMenuSeparator, g as DropdownMenuShortcut, _ as DropdownMenuSub, y as DropdownMenuSubContent, v as DropdownMenuSubTrigger, s as DropdownMenuTrigger };
